import { createContext, Dispatch, ReactElement, SetStateAction, useState } from 'react'
import { IUser } from '../../interfaces/common'

export const UserContext = createContext<{
  user: IUser | null
  setUser: Dispatch<SetStateAction<IUser>>
}>({
  user: null,
  // eslint-disable-next-line @typescript-eslint/no-empty-function, prettier/prettier
  setUser: () => {},
})

interface IUserContextProvider {
  children: ReactElement
  defaultValue: IUser
}

export const UserContextProvider = ({ children, defaultValue }: IUserContextProvider) => {
  const [user, setUser] = useState<IUser>(defaultValue)

  return <UserContext.Provider value={{ user, setUser }}>{children}</UserContext.Provider>
}
